/* eslint-disable react/no-unescaped-entities */

import Slider from "react-slick";
import client1 from "../../../../assets/images/all-img/about/client1.png";
import client10 from "../../../../assets/images/all-img/about/client10.png";
import client2 from "../../../../assets/images/all-img/about/client2.png";
import client3 from "../../../../assets/images/all-img/about/client3.png";
import client4 from "../../../../assets/images/all-img/about/client4.png";
import client5 from "../../../../assets/images/all-img/about/client5.png";
import client6 from "../../../../assets/images/all-img/about/client6.png";
import client7 from "../../../../assets/images/all-img/about/client7.png";
import client8 from "../../../../assets/images/all-img/about/client8.png";
import client9 from "../../../../assets/images/all-img/about/client9.png";

export default function ClientSliderTwo() {
	const settting = {
		rows: 2,
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 10000,
		cssEase: "linear",
		pauseOnHover: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};
	return (
		<div className="fugu-client-section">
			<div className="container">
				<div className="fugu-client-title">
					<h5>TTrusted by 1600+ of the world's most popular companies</h5>
				</div>
				<div className="fugu-client-slider2">
					<Slider {...settting}>
						<div className="fugu-brand-logo">
							<img src={client1} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client2} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client3} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client4} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client5} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client6} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client7} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client8} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client9} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client10} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client1} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client2} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client3} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client4} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client5} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client6} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client7} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client8} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client9} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client10} alt="" />
						</div>
					</Slider>
				</div>
			</div>
		</div>
	);
}
